export const isAuthPage = (location) => {
    return ['/', '/login', '/download'].indexOf(location) !== -1 || location.indexOf('/reset-password') > -1;
};

export const objectCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};



// WEBPACK FOOTER //
// ./src/utils/utils.js